import {Link, useNavigate, useParams} from "react-router-dom";
import {useOrder} from "./useOrder";
import {AdminUserAlert, ColumnizeText, ItemLoading, OurClearAlert, PageTitle, SelectText, SingleText} from "../../_components";
import React, {useState} from "react";
import {Formik, Form as FormikForm, Field, FieldArray} from "formik";
import {useAlert} from "../../../context";
import {Button, InputGroup, Stack, Form} from "react-bootstrap";
import {useCountryList} from "../admin/country/useCountry";
import {isoTimestampToReadableDate} from "../admin/utilities/readableDate";
import {ButtonDelete} from "../../_components/DeleteButton";
import {centsToUnits} from "../admin/utilities/formatCurrency";
import {AdjustQuantityCart} from "../../shop/_components/AdjustQuantity";
import {getVat, scrollToTop} from "../../../utils2";


export function OrderEdit() {
    const {oid} = useParams()
    const {success, error} = useAlert()
    const navigate = useNavigate()

    const [voucher, setVoucher] = useState("")

    const {
        value,
        validationSchema,
        editItem,
        deleteItem,
        getInvoice,
        loadingValue,
        errorValue,
        clearErrorValue
    } = useOrder(oid)

    const {list, loadingList} = useCountryList(100)

    function handleSubmit(values, actions) {
        // console.log("submit", values)
        editItem(values)
            .then(msg => {
                success(msg)
                navigate(-1)
            })
            .catch(console.warn)
            .finally(() => actions.setSubmitting(false))
    }

    function handleOnDelete() {
        deleteItem()
            .then(msg => {
                success(msg)
                navigate(-1)
            })
            .catch(console.warn)
    }

    function handleDownload() {
        getInvoice(value.id)
            .then(() => {
                scrollToTop()
            })
            .catch((err) => {
                error("Cannot download the PDF")
                console.error('Error downloading the PDF:', err)
            })
    }

    return <>
        <AdminUserAlert/>
        <OurClearAlert variant="danger" msg={errorValue} onClear={clearErrorValue}/>

        <PageTitle title="Orders Details">Edit order {value.order_number}.</PageTitle>

        {value && !loadingValue && !loadingList ? (
            new Date(value.shipped_at) !== new Date() ? (

                <Formik validationSchema={validationSchema} onSubmit={handleSubmit} initialValues={value} enableReinitialize={true}>
                    {({isSubmitting, resetForm, values}) => (
                        <FormikForm>

                            <FieldArray name="order_articles" component={ArticleDetails}/>

                            <div className="d-flex justify-content-between align-items-center">
                                <div>
                                    <ArticleSubdetail title="Delivery method"
                                                      value={
                                                          <span>{value.shipping_company}, {value.shipping_service}, € {centsToUnits(value.shipping_price_in_cents)} (incl. VAT €{centsToUnits(Number(value.shipping_price_in_cents) + parseFloat(getVat(value.shipping_price_in_cents, value.vat_percentage)))})</span>}/>
                                    <ArticleSubdetail title="Payment method" value={value.payment_method}/>
                                    <ArticleSubdetail title="Total payed (incl. VAT)" value={<span>€ {centsToUnits(value.total_gross_in_cents)}</span>}/>
                                </div>
                                <div className="">
                                    <InputGroup className="my-2">
                                        <InputGroup.Text>Discount %</InputGroup.Text>
                                        <Form.Control
                                            value={voucher}
                                            onChange={(e) => setVoucher(e.target.value)}
                                        />
                                    </InputGroup>
                                    <div className="text-danger">Total (incl VAT) preview: €
                                        {Number(
                                            (
                                                (
                                                    Number(values.shipping_price_in_cents) +
                                                    Math.round(getVat(Number(values.shipping_price_in_cents), values.vat_percentage)) +
                                                    values.order_articles.reduce((sum, article) => {
                                                        const base = Number(article.quantity) * Number(article.unit_price_in_cents);
                                                        const vat = article.quantity * Math.round(getVat(Number(article.unit_price_in_cents), values.vat_percentage));
                                                        return sum + base + vat;
                                                    }, 0)
                                                ) * (1 - (Number(voucher) / 100))
                                            ) / 100
                                        ).toFixed(2)}

                                        {/*{centsToUnits(Math.round(values.total_gross_in_cents - (values.total_gross_in_cents * Number(voucher) / 100)))}*/}
                                    </div>
                                </div>
                            </div>

                            <div className="fw-medium mt-4">Shipping address</div>
                            <ColumnizeText>
                                <SingleText name="shipping_name" label="Name" maxLength="64"/>
                                <SingleText name="shipping_phone" label={null} maxLength="64" prefix="+"/>
                            </ColumnizeText>
                            <ColumnizeText className="">
                                <SingleText name="shipping_line1" label="Address" placeholder="Street, house/apartment/unit"/>
                                <SingleText name="shipping_line2" label={null} placeholder="Apt., suite, unit, etc (optional)"/>
                            </ColumnizeText>
                            <ColumnizeText className="">
                                <SelectText name="shipping_country" label={null}>
                                    {list.map(item => (
                                        <option key={item.code} value={item.code}>{item.name}</option>
                                    ))}
                                </SelectText>
                                <SingleText name="shipping_region" label={null} placeholder="State/province/region"/>
                            </ColumnizeText>
                            <ColumnizeText className="">
                                <SingleText name="shipping_city" label={null} placeholder="City"/>
                                <SingleText name="shipping_zip" label={null} placeholder="Postal code/ZIP code"/>
                            </ColumnizeText>

                            <div className="fw-medium mt-4">Billing address</div>
                            <ColumnizeText>
                                <SingleText name="billing_name" label="Name" maxLength="64"/>
                                <SingleText name="billing_phone" label={null} maxLength="64" prefix="+"/>
                            </ColumnizeText>
                            <ColumnizeText className="">
                                <SingleText name="billing_line1" label="Address" placeholder="Street, house/apartment/unit"/>
                                <SingleText name="billing_line2" label={null} placeholder="Apt., suite, unit, etc (optional)"/>
                            </ColumnizeText>
                            <ColumnizeText className="">
                                <SelectText name="billing_country" label={null}>
                                    {list.map(item => (
                                        <option key={item.code} value={item.code}>{item.name}</option>
                                    ))}
                                </SelectText>
                                <SingleText name="billing_region" label={null} placeholder="State/province/region"/>
                            </ColumnizeText>
                            <ColumnizeText className="">
                                <SingleText name="billing_city" label={null} placeholder="City"/>
                                <SingleText name="billing_zip" label={null} placeholder="Postal code/ZIP code"/>
                            </ColumnizeText>

                            <Stack className="my-2 text-secondary">
                                <div>
                                    <span className="fw-semibold">Created at</span>
                                    <span>: {value.created_at ? isoTimestampToReadableDate(value.created_at) : "Never"}</span>
                                </div>
                                <div>
                                    <span className="fw-semibold">Updated at </span>
                                    <span>: {value.updated_at ? isoTimestampToReadableDate(value.updated_at) : "Never"}</span>
                                </div>
                            </Stack>

                            <Stack direction="horizontal" gap="2" className="py-3 justify-content-end">
                                <Button as={Link} variant="link" to={-1}>Go back</Button>
                                < Button variant="warning" onClick={handleDownload}>Invoice</Button>
                                <ButtonDelete variant="danger" onDelete={handleOnDelete} value={value.name}>Delete</ButtonDelete>
                                <Button type="submit" variant="success" disabled={isSubmitting}>Edit</Button>
                            </Stack>

                        </FormikForm>
                    )}
                </Formik>
            ) : (
                <p>The order has already shipped.</p>
            )
        ) : (
            <ItemLoading show={loadingValue && loadingList}/>
        )}
    </>
}

function ArticleDetails({form, remove}) {

    return (
        form.values.order_articles.map((article, index) => (
                <div key={index} className="my-2 d-flex justify-content-between">
                    <div>
                        <Link to={`/shop/detail/${article.product_id}`}
                              className="flex-shrink-0 link-body-emphasis link-underline link-underline-opacity-0 link-underline-opacity-75-hover link-offset-1 link-offset-1-hover fw-semibold">{article.title}</Link>
                        <ArticleSubdetail title="SKU" value={<Link to={`/backend/product/${article.product_id}`}
                                                                   className="flex-shrink-0 link-body-emphasis link-underline link-underline-opacity-0 link-underline-opacity-75-hover link-offset-1 link-offset-1-hover">{article.SKU}</Link>}/>
                        <ArticleSubdetail title="Base price" value={`€ ${centsToUnits(article.base_price_in_cents)}`}/>
                        <ArticleSubdetail title="Unit price" value={`€ ${centsToUnits(article.unit_price_in_cents)}`}/>
                        <ArticleSubdetail title={`VAT ${form.values.vat_percentage}%`}
                                          value={`€ ${getVat(form.values.order_articles[index].unit_price_in_cents, form.values.vat_percentage) / 100}`}/>
                        <ArticleSubdetail title="Total (incl. VAT)"
                                          value={<div className="d-flex">
                                              <div>€ {centsToUnits(article.total_price_in_cents + parseFloat(getVat(form.values.order_articles[0].total_price_in_cents, form.values.vat_percentage)))}</div>
                                              <div className="text-danger ms-2">Preview: € {centsToUnits(article.unit_price_in_cents * article.quantity
                                                  + parseFloat(getVat((article.unit_price_in_cents * article.quantity), form.values.vat_percentage)))}</div>
                                          </div>}
                        />
                    </div>

                    <div className="gap-2">
                        <Field name={`order_articles.${index}.quantity`}>
                            {({field}) => (
                                <div className="">
                                    <div className="text-body-secondary">Quantity</div>
                                    <AdjustQuantityCart name={field.name} value={field.value} onChange={field.onChange}/>
                                    <Button variant="link" className="text-decoration-none" onClick={remove}>
                                        <div className="text-danger small">Remove</div>
                                    </Button>
                                </div>
                            )}
                        </Field>
                        {/*<Button variant="outline-danger" className="border-0" onClick={remove}><i className="bi bi-trash"/></Button>*/}
                    </div>

                </div>
            )
        ))
}

function ArticleSubdetail({title, value}) {
    return <div className="d-flex">
        <div className="text-body-secondary me-2">{title}:</div>
        <div>{value}</div>
    </div>
}